import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { isEmpty, get } from 'lodash';
import asyncRoute from '../../../helpers/hoc/asyncRoute';
import { validateResetPassword, changePasswordAction } from '../../../actions';
import { formFields } from "./constant";
import Input from '../../../components/FormElements/Input';
import { handleFieldError, handleError } from '../../../utils/form-validation';
import routes from '../../../routes';
import ModalConfirmation from '../../../components/ModalConfirmation';
import imgauth from '../../../assets/images/illustrations/auth-login-illustration-dark.png';
import imgBg from '../../../assets/images/illustrations/bg-shape-image-light.png';
import infomoImg from '../../../assets/images/bekiLogo.png';
import ToastModal from '../../../components/ToastModal';
import CryptoJS from 'crypto-js';
import { encryptDataWithBlowfish } from '../../../selectors';
import { defaultPlatformConfig } from '../../../constants/configuration';

const AuthenticationCard = asyncRoute(() => import('../../../components/Card/AuthenticationCard'));
const TextField = asyncRoute(() => import('../../../components/elements/TextField'));
const Button = asyncRoute(() => import('../../../components/elements/Button'));
const AuthenticationBody = asyncRoute(() => import('../../../components/AuthenticationBody'));

class ResetPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            form: {},
            touched: {},
            errors: {},
            submited: false,
            isForgotSubmitDisabled: true,
            validateSuccess: false,
            confirmationOpen: false,
            confirmationInfo: '',
            enableToast: false,
            toastStatus: "",
            toastMsg: "",
            confirmationMsg: "",
            method: '',
            logoImage: '',
            platformName: ''
        };
    }


    checkForgotSubmitDisabled() {
        const { form } = this.state;
        let { valid } = handleError(form, formFields);
        return (isEmpty(form.password) || isEmpty(form.confirmPw) || !valid);
    }

    async componentWillMount() {
        const { location, validateResetPassword, platformConfiguration } = this.props;
        let platformName = platformConfiguration['name'] ? platformConfiguration['name'] : defaultPlatformConfig['name'];
        let logoImageUrl = defaultPlatformConfig['lable']['logo'][0]['path'];
        if (platformConfiguration && platformConfiguration['lable']['logo'] && platformConfiguration['lable']['logo'].length > 0) {
            if (platformConfiguration['lable']['logo'][0].hasOwnProperty('path')) {
                logoImageUrl = platformConfiguration['lable']['logo'][0]['path'];
            }
        } else {
            logoImageUrl = defaultPlatformConfig['lable']['logo'][0]['path'];
        }
        this.setState({ logoImage: logoImageUrl, platformName });
        let search = location.search
        const params = new URLSearchParams(search);
        const rp = params.get('rp');
        // const uid = params.get('uid');
        const { responseCode: { status } } = await validateResetPassword({ rp })
        // const { responeCode: { status } } = await validateResetPassword({ rp, uid })
        if (status == "Success") {
            this.setState({ validateSuccess: true })
        } else {
            // let info = { action: { confirmationMessage: 'Not a Valid Url.', type: 'urlError' } }
            let info = { action: { confirmationMessage: 'The link has either been used or has expired. For security reasons, password reset links are only valid for a limited time. Please request a new password reset link to set your password', type: 'urlError' } }
            this.setState({ validateSuccess: false }, () => this.toggleModal(info))
        }

    }

    componentWillUnmount() {
        formFields.confirmPw.customError = false;
    }

    toggleModal = (confirmation) => {
        const { confirmationOpen } = this.state;
        this.setState({ confirmationOpen: !confirmationOpen, confirmationInfo: confirmation })
    }

    confirmationCallBack = (success, info) => {
        const { confirmationOpen } = this.state;
        const { history } = this.props;
        if (info.action.type === 'alert') {
            this.setState({ confirmationOpen: !confirmationOpen }, () => history.push(routes.preSignIn))
            return;
        } else if (info.action.type === 'error') {
            this.setState({ confirmationOpen: !confirmationOpen })
            return;
        } else if (info.action.type === 'urlError') {
            this.setState({ confirmationOpen: !confirmationOpen }, () => history.push(routes.preSignIn))
            return;
        }
        this.setState({ confirmationOpen: false });
    }

    handleResetSubmit = (e) => {
        e.preventDefault();
        const { form } = this.state;
        let { errors, valid } = handleError(form, formFields);
        const { confirmPw, password } = form;
        if (valid) {
            if (password != confirmPw) {
                // let info = { action: { confirmationMessage: 'Password and confirm password should be same.', type: 'error' } }
                // this.toggleModal(info)
                // this.setState({ enableToast: true, toastMsg: "Password and Confirm Password should be same.", toastStatus: "Fail", method: 'Save' });
                this.setState({ enableToast: true, toastMsg: "Make sure the entered password matches the one you provided above", toastStatus: "Fail", method: 'Save' });
                return false;
            } else {
                // this.submitForm()
                this.setState({ enableToast: true, confirmationMsg: "Kindly let us know if you'd like to save your changes.", toastMsg: "", toastStatus: "", method: 'Save' });

            }
        } else {
            this.setState({ errors: errors, submited: true });
        }
    }

    async submitForm() {
        const { location, changePasswordAction } = this.props;
        const { form } = this.state;
        let search = location.search;
        const params = new URLSearchParams(search);
        const rp = params.get('rp');
        // const authUser = params.get('uid');
        // let password = form.password
        let password = CryptoJS.MD5(form.password).toString();
        password = await encryptDataWithBlowfish(password, 'string');

        const { responseCode: { status = '', msg = '' } } = await changePasswordAction({ password, rp })
        // const { responeCode: { status } } = await changePasswordAction({ password, rp, authUser })
        if (status == 'Success') {
            // let successfullyMessage = { action: { confirmationMessage: 'Successfully change password.', type: 'alert' } }
            // this.setState({ confirmationOpen: false, form: {}, errors: {} }, () => {
            //     this.toggleModal(successfullyMessage);
            // })
            this.toast(status, 'Your password has been configured successfully, Please continue to Login.')
            return;
        } else {
            // let info = { action: { confirmationMessage: 'Error occurs', type: 'error' } }
            this.setState({ enableToast: true, toastMsg: "Error occurs", toastStatus: "Fail", method: 'Save' });

            // this.toggleModal(info);
        }
    }

    handleChange = (e) => {
        let { form } = this.state;
        let { value, name } = e.target;
        form[name] = value;
        this.setState({ form }, async () => {
            const isForgotSubmitDisabled = this.checkForgotSubmitDisabled();
            this.setState({
                isForgotSubmitDisabled,
            });
            await this.checkValidationMatchString(name)
            this.handleTouch({ target: { name: name } })
        });
    }

    checkValidationMatchString = async (name) => {
        const { form } = this.state;
        if (form.password && form.password.length > 0 && form.confirmPw && form.confirmPw.length > 0 && form.password != form.confirmPw) {
            formFields.confirmPw.customError = true;
            if (name == "password") {
                this.handleTouch({ target: { name: 'confirmPw' } })
            }
        }
        else if (form.password && form.password.length > 0 && form.confirmPw && form.confirmPw.length > 0 && form.password == form.confirmPw) {
            formFields.confirmPw.customError = false;
            if (name == "password") {
                this.handleTouch({ target: { name: 'confirmPw' } })
            }
        }
        else {
            formFields.confirmPw.customError = false

        }

    }

    handleTouch = (e) => {
        let { touched, form, errors } = this.state;
        let { error } = handleFieldError(form[e.target.name], formFields[e.target.name]);
        errors[e.target.name] = error;
        touched[e.target.name] = true;
        this.setState({ touched, errors });
    }
    handlePassword = async (e) => {
        // const {formFieldsState} = this.props
        if (formFields.password.type === 'password') {
            formFields.password.type = "text"
        } else {
            formFields.password.type = "password"
        }
        // if (formFields.confirmPw.type === 'password') {
        //     formFields.confirmPw.type = "text"
        // } else {
        //     formFields.confirmPw.type = "password"
        // }

        return this.setState(formFields)
    }


    handleConfirmPassword = async (e) => {
        if (formFields.confirmPw.type === 'password') {
            formFields.confirmPw.type = "text"
        } else {
            formFields.confirmPw.type = "password"
        }

        return this.setState(formFields)

    }

    toast = (status, msg) => {
        this.setState({ enableToast: true, toastStatus: status, toastMsg: msg });
        return;
    }

    confirmationCallbackModel = (id) => {
        const { method, } = this.state;
        this.setState({ enableToast: false }, () => {
            if (method === "Save") {
                this.submitForm();
            }
        });
    }


    handleToastStatus = (status) => {
        const { method } = this.state;
        this.setState({ enableToast: status }, () => {
            if (method === "Save") {
                // this.getSegmentData();
            }
        });
    }

    passwordValidation = (propsData) => {

        const { password = '' } = propsData

        function renderErrorMessage(condition, message) {
            if (!condition) {
                return <p className='error-message' style={{ marginBottom: 0 }}>{message}</p>;
            }
            return null;
        }

        return (
            <div style={{ marginTop: -15 }}>
                {renderErrorMessage(/(?=.*[A-Z])/.test(password), "- Contain at least one uppercase letter (A-Z).")}
                {renderErrorMessage(/(?=(?:.*[a-z]){5,})/.test(password), "- Contain at least five lowercase letters (a-z).")}
                {renderErrorMessage(/.*\d.*\d.*/.test(password), "- Include at least two digits (0-9).")}
                {renderErrorMessage(/(?=.*[@$!%*?&])/.test(password), "- Include at least one special character (@$!%*?&).")}
                {renderErrorMessage(!(password.length < 9), "- Be at least 9 characters long.")}
            </div>
        );
    }

    render() {
        const { confirmationOpen, confirmationInfo, isForgotSubmitDisabled, validateSuccess, form, errors, submited, touched, err, enableToast, toastMsg, toastStatus, confirmationMsg, method, logoImage, platformName } = this.state;
        return (
            <>
                {confirmationOpen && (<ModalConfirmation
                    open={confirmationOpen}
                    onClose={this.toggleModal}
                    confirmationInfo={confirmationInfo}
                    handelConfirmationMessage={this.confirmationCallBack}
                />)}

                {
                    enableToast && <ToastModal
                        enableToast={enableToast}
                        status={toastStatus}
                        msg={toastMsg}
                        path={routes.preSignIn}
                        idProps={this.props}
                        handleConfirmation={this.confirmationCallbackModel}
                        handleToastStatus={this.handleToastStatus}
                        confirmationMsg={confirmationMsg}
                    />
                }
                {validateSuccess && <AuthenticationBody>
                    {/* <AuthenticationCard> */}
                    <div class="d-none d-lg-flex col-lg-7 p-0">
                        <div class="auth-cover-bg auth-cover-bg-color d-flex justify-content-center align-items-center">
                            <img
                                src={imgauth}
                                alt="auth-login-cover"
                                class="img-fluid my-5 auth-illustration"
                                data-app-light-img="illustrations/auth-login-illustration-light.png"
                                data-app-dark-img="illustrations/auth-login-illustration-dark.png"
                            />

                            <img
                                src={imgBg}
                                alt="auth-login-cover"
                                class="platform-bg"
                                data-app-light-img="illustrations/bg-shape-image-light.png"
                                data-app-dark-img="illustrations/bg-shape-image-dark.png"
                            />
                        </div>
                    </div>
                    <div class="d-flex col-12 col-lg-5 align-items-center p-sm-5 p-4">
                        <div class="w-px-400 mx-auto">
                            <div class="app-brand mb-4">
                                <a href="#" class="app-brand-link gap-2">
                                    <img style={{ width: '30%' }} src={logoImage} />
                                </a>
                            </div>
                            <h3 class="mb-1 fw-bold">Welcome to {platformName.toLowerCase()}! 👋</h3>
                            <p class="mb-4">Please reset your account password</p>

                            <form id="formAuthentication" class="mb-3" onSubmit={this.handleResetSubmit}>
                                <div class="mb-3 ">
                                    <div style={{ position: 'relative' }}>
                                        <Input
                                            onChange={this.handleChange}
                                            onBlur={this.handleTouch}
                                            value={form[formFields.password.key]}
                                            setting={formFields[formFields.password.key]}
                                            error={errors[formFields.password.key]}
                                            submited={submited}
                                            touched={touched[formFields.password.key]}
                                        />
                                        <i style={{ position: 'absolute', top: 42, right: 15 }} onClick={this.handlePassword} class={`ti ${formFields.password.type == "password" ? "ti-eye-off" : "ti-eye"} cursor-pointer`}>
                                        </i>
                                    </div>
                                    {
                                        errors[formFields.password.key] &&
                                        <this.passwordValidation password={form[formFields.password.key]} />
                                    }
                                </div>
                                <div class="mb-3">
                                    <div style={{ position: 'relative' }}>
                                        <Input
                                            onChange={this.handleChange}
                                            onBlur={this.handleTouch}
                                            value={form[formFields.confirmPw.key]}
                                            setting={formFields[formFields.confirmPw.key]}
                                            error={errors[formFields.confirmPw.key]}
                                            submited={submited}
                                            touched={touched[formFields.confirmPw.key]}
                                        />
                                        <i style={{ position: 'absolute', top: 42, right: 15 }} onClick={this.handleConfirmPassword} class={`ti ${formFields.confirmPw.type == "password" ? "ti-eye-off" : "ti-eye"} cursor-pointer`}>
                                        </i>
                                    </div>
                                    {
                                        errors[formFields.confirmPw.key] &&
                                        <this.passwordValidation password={form[formFields.confirmPw.key]} />
                                    }
                                </div>
                                <button style={{ marginTop: '3rem' }} disabled={this.checkForgotSubmitDisabled()} class="btn btn-primary d-grid w-100">Reset Password</button>
                            </form>
                        </div>
                    </div >
                    {/* </AuthenticationCard> */}
                </AuthenticationBody>}
            </>
        );
    }
}



export default connect(
    state => ({
        preSignInStatus: get(state, 'app.preSignInData.responeCode.status', ''),
        platformConfiguration: get(state, 'app.platformConfiguration', '')
    }),
    {
        validateResetPassword,
        changePasswordAction
    }
)(withRouter(ResetPassword))

